<script>
import { UtcDate } from '@/helpers/date';
import QuestionBaseRadioBoolean from './BaseRadioBoolean.vue';

export default {
  name: 'question-classic-car-club',
  extends: QuestionBaseRadioBoolean,
  created () {
    this.$watch(() => this.showRulesValidity, () => {
      // TODO: implement cross step show rules
      if (!this.isShown) {
        this.showRulesValidity = false;
        this.questionData[this.questionFields.field] = null;
      }
    }, {
      immediate: true,
    });
  },
  computed: {
    isShown () {
      const today = new UtcDate();
      const classicCarYear = today.subYears(25).format('yyyy');
      return classicCarYear >= this.formData.vehicle.yearOfManufacture;
    },
  },
};
</script>
